import { useEffect } from 'react';
import { Box } from '@type/layoutEditor/Box';

export const useAdjustElementSizeToPreview = (
  element: {
    id: number;
    x: number;
    y: number;
    width: number;
    height: number;
  },
  fetchedPreview: { contentWidth?: number; contentHeight?: number } | undefined,
  bounds: { width: number; height: number },
  updaterFn: (updatedElement: Box & { id: number }) => void,
) => {
  useEffect(() => {
    const fetchedPreviewWidth = fetchedPreview?.contentWidth;
    const fetchedPreviewHeight = fetchedPreview?.contentHeight;
    if (
      !!element &&
      !!fetchedPreview &&
      (fetchedPreviewWidth > element?.width || fetchedPreviewHeight > element?.height)
    ) {
      updaterFn({
        id: element.id,
        x: element.x,
        y: element.y,
        width: Math.min(fetchedPreviewWidth, bounds.width),
        height: Math.min(fetchedPreviewHeight, bounds.height),
      });
    }
  }, [fetchedPreview]);
};
